import { render } from "./Publication.vue?vue&type=template&id=08039faa&scoped=true"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"

import "./Publication.vue?vue&type=style&index=0&id=08039faa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08039faa"

export default script